The conflict result for the `uploadCandidate` mutation.
